import { SearchUserRequest, SearchUserResultExternal } from '@askporter/client-grieg-lyric';
import { API } from './api';

export default async ({ payload }: { payload: SearchUserRequest }): Promise<SearchUserResultExternal> => {
  const { data } = await API().post({ path: 'users/search', payload });
  return data;
};
